<template>
<v-container class="app-page-container">
    <div v-if="needInit">{{initData()}}</div>
    <div v-if="getShowModalMessageResult">{{processModalResult()}}</div>
        <v-card class="app-page-card shadow-none">
            <v-card-title>
                Member of groups:
            </v-card-title>
            <v-card-text>
            <v-layout word wrap>
                <v-flex xs1></v-flex>
                <v-flex xs10>
                    <p>Double click to set as primary group</p>                    
                    <v-chip v-for="(item,index) in my_groups" 
                            class="p20 border-radius-md"
                            :key="index" style="margin:2px"
                            :color="getChipColor(item)" >
                        {{item.name}}
                        <v-icon x-small class="btn-close" @click="deleteMemberGroup(item)">close</v-icon>
                    </v-chip>
                    <p></p>
                    <v-layout justify-center v-if="feedback1">
                        <p style="color:red">{{feedback1}}</p>
                    </v-layout>                
                </v-flex>
                <v-flex xs1></v-flex>
                <v-flex xs1></v-flex>
                <v-flex xs10>
                    <v-autocomplete
                        v-model="groups1"
                        :items="group_list"
                        :search-input.sync="search1"
                        hide-selected
                        label="Add groups"
                        multiple                        
                        small-chips
                        @input="addToGroups()"
                    ></v-autocomplete>
                </v-flex>
            </v-layout>
            </v-card-text>
        </v-card>
        <v-card class="app-page-card shadow-none">
            <v-card-title>
                    Created groups:
            </v-card-title>
            <v-card-text>
                <v-layout word wrap>
                    <v-flex xs1></v-flex>
                    <v-flex xs10>
                        <p>Double click for edit</p>
                        <v-chip v-for="(item,index) in my_owns" 
                            :key="index" :color="getChipColor(item)" 
                            @dblclick="ownedGroupDblClick(item)"
                            style="margin:2px">
                            <v-icon x-small class="btn-close" @click="deleteOwnedGroup(item)">close</v-icon>
                                {{item.name}}
                        </v-chip>
                    </v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs10>
                        <v-layout justify-center>
                            <p v-if="feedback" style="color:red">{{feedback}}</p>
                        </v-layout>
                    </v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs12 v-if="show_group_info == 1">
                       <v-card>
                           <v-card-title>
                               Group info
                           <v-icon 
                                  class="btn-close"
                                  @click="show_group_info = 0; feedback=null"
                                  >
                                close</v-icon> 
                            </v-card-title>
                           <v-card-text>
                               <v-row>
                                <v-col cols = 4>
                                        <v-text-field
                                            :label="getGroupLabel(processed_group.type)"
                                            v-model="processed_group.name"
                                        ></v-text-field>
                                </v-col>
                                <v-col cols = 3>
                                        <v-text-field v-if="processed_group.type==0"
                                            label="Group key"
                                            v-model="processed_group.group_key"
                                        ></v-text-field>
                                </v-col>
                                <v-col cols = 3>
                                        <v-text-field v-if="processed_group.type==0"
                                            label="Teacher key"
                                            v-model="processed_group.teacher_key"
                                        ></v-text-field>
                                </v-col>     
                                <v-col cols=1>
                                     <v-icon x-large color="green" @click="changeOwnedGroup()">done</v-icon>   
                                </v-col>
                               </v-row> 
                               
                           </v-card-text>
                       </v-card>     
                    </v-flex>
                    <v-flex xs12 md10 v-if="show_group_info == 3">
                       <v-card class="card-border-style shadow-none mb-10">
                           <v-card-title>
                               New group
                           <v-icon 
                                  class="btn-close"
                                  @click="show_group_info = 0; feedback = null"
                                  >
                                close</v-icon> 
                           </v-card-title>
                           <v-card-text>
                               <v-container fill-height>
                                  <v-row justify="center" align="center">
                                    <v-col cols="12" md="6">
                                        <v-select
                                            v-model="newGroup.gtype"
                                            :items="pp"
                                            label="Group type"
                                            ></v-select>
                                    </v-col>                                
                                    <v-col cols="12" md="6">
                                            <v-text-field
                                                :label="'Type '+ newGroup.gtype +' group name'"
                                                v-model="newGroup.name"
                                            ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                            <v-text-field v-if="newGroup.gtype=='private'"
                                                label="Group key"
                                                v-model="newGroup.group_key"
                                            ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                            <v-text-field v-if="newGroup.gtype=='private'"
                                                label="Teacher key"
                                                v-model="newGroup.teacher_key"
                                            ></v-text-field>
                                    </v-col>     
                                    <v-col cols="12">
                                        <v-icon x-large @click="saveOwnedGroup()" class="float-right color-green">done</v-icon>   
                                    </v-col>
                                  </v-row> 
                               </v-container>
                           </v-card-text>
                       </v-card>     
                    </v-flex>
                    <v-flex xs12>
                        <v-layout justify-center>
                            <v-icon size="x-large" @click="addGroup()">mdi-plus-circle-outline</v-icon> 
                        </v-layout>
                    </v-flex>
                    <v-flex xs1></v-flex>

                </v-layout>
            </v-card-text>
        </v-card>
         <v-card class="app-page-card shadow-none">
            <v-card-title>
                    Teacher of groups:
            </v-card-title>
            <v-card-text>
                <v-layout word wrap>
                    <v-flex xs1></v-flex>
                    <v-flex xs10>
                        <v-chip v-for="(item,index) in my_teach_groups" :key="index" style="margin:2px">
                            <v-icon x-small class="btn-close" @click="deleteTeacherGroup(item)">close</v-icon>
                            {{item.name}}
                        </v-chip>
                    </v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs10>
                        <v-layout justify-center v-if="feedback2">
                            <p style="color:red">{{feedback2}}</p>
                        </v-layout>                

                        <v-autocomplete @input="addToTeacherGroups()"
                            v-model="groups2"
                            :items="private_group_list"
                            :search-input.sync="search2"
                            hide-selected
                            label="Add groups"
                            multiple
                            small-chips
                        ></v-autocomplete>
                    </v-flex>                    
                </v-layout>
            </v-card-text>
        </v-card>
<!--             <v-simple-table dense fixed-header height="400px">
                <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="text-left">Owner</th>
                        <th class="text-left">Member</th>
                        <th class="text-left">Primary</th>
                        <th class="text-left">Name</th>
                        <th class="text-left">Type</th>
                        <th class="text-left">Teacher?</th>                        
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in groups" :key="index">
                        <td><v-icon>{{getIcon(item.owner)}}</v-icon></td>
                        <td><v-icon>{{getIcon(item.member)}}</v-icon></td>
                        <td><v-icon>{{getIcon(item.primary)}}</v-icon></td>
                        <td>{{ item.name }}</td>
                        <td>
                            <v-icon v-if="item.type==0" >lock</v-icon>
                            <v-icon v-if="item.type==1" >login</v-icon>
                        </td>
                          <td>{{getTeach(item)}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table> -->
    </v-container>
</template>

<script>
import axios from '../../axios-auth.js'
import {mapGetters} from 'vuex'

export default {
    computed: 
        mapGetters([
                    'getShowModalMessageResult'                    
                ])
    ,
    data() {
        return {
            needInit: true,
            groups: null,
            my_groups: null,
            my_owns: null,
            my_teach_groups: null,
            groups1: [],
            search1: null,
            groups2: [],
            search2: null,
            group_list: null,
            private_group_list: null,
            show_group_info: 0,
            processed_group : null,
            feedback: null,
            feedback1: null,
            feedback2: null,
            newGroup : null,
            pp: ['private','public'],
            full_group: null
        }
    },
    mounted() {
        this.needInit = true
    },
    methods : {
        initData() {
            this.needInit = false
            // give me my groups
            axios.get('/get-my-groups', this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.groups = res.data.groups
                    this.my_owns = res.data.my_owns
                    this.my_groups = res.data.my_groups
                    this.my_teach_groups = res.data.teach_groups
                    this.refreshDataForCombo(this.groups)                   
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 
        },
        getChipColor(item) {
            if (item.type == 0) return "yellow"
            return ""
        },
        ownedGroupDblClick(item) {
            this.feedback = null
            this.show_group_info = 1
            this.processed_group = {
                id : item.id,
                name: item.name,
                type: item.type,
                group_key: item.group_key,
                teacher_key : item.teacher_key
            }

        },
        getGroupLabel(t) {
            if (t == 0) return "Private group name"
            return "Public group name"
        },
        deleteOwnedGroup(item){
            this.show_group_info = 0
            this.processed_group = item
            this.$store.commit('setShowModalMessage',
                               {content: 'Are you sure?<br/>You want to delete group "' + this.processed_group.name + '"', type: 'warning', 
                                buttons:[], icons:[{text:'close', color:'red', value: 1},{text:'done', color:'green', value: 2} ]})
        },
        deleteTeacherGroup(item){
            this.show_group_info = 2
            this.processed_group = item
            this.$store.commit('setShowModalMessage',
                               {content: 'Are you sure?<br/>You want to stop teaching group "' + this.processed_group.name + '"', type: 'warning', 
                                buttons:[], icons:[{text:'close', color:'red', value: 3},{text:'done', color:'green', value: 4} ]})
        },
        deleteMemberGroup(item){
            this.show_group_info = 2
            this.processed_group = item
            this.$store.commit('setShowModalMessage',
                               {content: 'Are you sure?<br/>You want to lost your membership in group "' + this.processed_group.name + '"', type: 'warning', 
                                buttons:[], icons:[{text:'close', color:'red', value: 5},{text:'done', color:'green', value: 6} ]})
        },
        processModalResult() {
            this.show_group_info = 0
            const res = this.getShowModalMessageResult
            this.$store.commit('setShowModalMessageResult',null)
            if (res == 2) {
                this.deleteGroup({ group_type: 'owner', id: this.processed_group.id})
            }
            if (res == 4) {
                this.deleteGroup({ group_type: 'teacher', id: this.processed_group.id})
            }
            if (res == 6) {
                this.deleteGroup({ group_type: 'member', id: this.processed_group.id})
            }
            if (res == 8) {
                this.full_group.group_key = this.$store.getters.getShowModalMessageText
                this.addNewGroup(1)
            }
            if (res == 10) {
                this.full_group.teacher_key = this.$store.getters.getShowModalMessageText
                this.addNewGroup(2)
            }

        },
        deleteGroup(data) {
            this.feedback = null
            axios.post('/delete-group', data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    // set data to store
                    if (data.group_type == 'owner') {
                        if (res.data.message == 'OK') {
                            // delete in local
                            for(let i = 0; i<this.groups.length; i++) {
                              if (this.groups[i].id == data.id) {
                                  this.groups.splice(i,1)
                                  break
                              }
                            }
                            for(let i = 0; i<this.my_owns.length; i++) {
                              if (this.my_owns[i].id == data.id) {
                                  this.my_owns.splice(i,1)
                                  break
                              }
                            }
                            for(let i = 0; i<this.my_teach_groups.length; i++) {
                              if (this.my_teach_groups[i].id == data.id) {
                                  this.my_teach_groups.splice(i,1)
                                  break
                              }
                            }
                            this.refreshDataForCombo(this.groups)
                        } else {
                            this.feedback = res.data.description
                        }
                    }
                    if (data.group_type == 'member') {
                        if (res.data.message == 'OK') {
                            // delete in local
                            for(let i = 0; i<this.my_groups.length; i++) {
                              if (this.my_groups[i].id == data.id) {
                                  this.my_groups.splice(i,1)
                                  break
                              }
                            }
                        }
                    }
                    if (data.group_type == 'teacher') {
                        if (res.data.message == 'OK') {
                            // delete in local
                            for(let i = 0; i<this.my_teach_groups.length; i++) {
                              if (this.my_teach_groups[i].id == data.id) {
                                  this.my_teach_groups.splice(i,1)
                                  break
                              }
                            }
                        }
                    }
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })             
        },
        changeOwnedGroup(){  
            this.feedback = null
            // check if name was changed
            for(let i=0; i<this.my_owns.length; i++) {
                if (this.processed_group.id == this.my_owns[i].id) {
                    if ((this.processed_group.name == this.my_owns[i].name) &&
                        (this.processed_group.teacher_key == this.my_owns[i].teacher_key) &&   
                        (this.processed_group.group_key == this.my_owns[i].group_key)) {                       
                          this.show_group_info = 0  
                          return
                        }
                    else break;
                }
            }

            if (!this.keyCheck(this.processed_group.type, this.processed_group.name, this.processed_group.group_key,this.processed_group.teacher_key)) {
                return
            }
            const data = {
                id : this.processed_group.id,
                name : this.processed_group.name,
                group_key : this.processed_group.group_key,
                teacher_key : this.processed_group.teacher_key,
                public: this.processed_group.type
            }
            // console.log(data)
            axios.post('/change-group', data, this.$store.getters.getAxiosConfig)
                .then(res => {       
                    // synchronize             
                    if (res.data.message == 'OK') {
                        // delete in local
                        for(let i = 0; i<this.groups.length; i++) {
                            if (this.groups[i].id == data.id) {
                                this.groups.splice(i,1, {
                                    id : this.processed_group.id, name : this.processed_group.name, group_key : this.processed_group.group_key,
                                    teacher_key : this.processed_group.teacher_key, type: this.processed_group.type
                                })
                                break
                            }
                        }
                        for(let i = 0; i<this.my_owns.length; i++) {
                            if (this.my_owns[i].id == data.id) {
                                this.my_owns.splice(i,1, {
                                    id : this.processed_group.id, name : this.processed_group.name, group_key : this.processed_group.group_key,
                                    teacher_key : this.processed_group.teacher_key, type: this.processed_group.type
                                })
                                break
                            }
                        }
                        for(let i = 0; i<this.my_teach_groups.length; i++) {
                            if (this.my_teach_groups[i].id == data.id) {
                                this.my_teach_groups.splice(i,1, {
                                    id : this.processed_group.id, name : this.processed_group.name, group_key : this.processed_group.group_key,
                                    teacher_key : this.processed_group.teacher_key, type: this.processed_group.type
                                })
                            }
                        }
                        for(let i = 0; i<this.my_groups.length; i++) {
                            if (this.my_groups[i].id == data.id) {
                                this.my_groups.splice(i,1,{
                                    id : this.processed_group.id, name : this.processed_group.name, group_key : this.processed_group.group_key,
                                    teacher_key : this.processed_group.teacher_key, type: this.processed_group.type
                                })
                            }
                        }
                        this.refreshDataForCombo(this.groups)
                        this.show_group_info = 0  
                    } else {
                        this.feedback = res.data.description
                    }
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 
        },
        refreshDataForCombo(groups) {
            this.group_list = []
            this.private_group_list = []
            // prepare for show
            for(let i = 0; i< groups.length; i++) {
                this.group_list.push(groups[i].name)
                if (this.groups[i].type == 0)
                    this.private_group_list.push(groups[i].name)
            }
        },
        addGroup() {
            this.newGroup = {
                name : '',
                gtype: 'public',
                teacher_key : '',
                group_key : ''
            }            
            this.show_group_info = 3
        },
        keyCheck(gt, gn, gk,tk) {
            if (gn.length < 5) {
                    this.feedback = 'Group name must have to at least 5 characters'
                    return false
            } 
            if (gt == 0) {
                if (gk.length < 5) {
                    this.feedback = 'Group key must have to at least 5 characters'
                    return false
                } 
                if (tk.length < 5) {
                    this.feedback = 'Teacher key must have to at least 5 characters'
                    return false
                } 
            }
            return true
        },
        saveOwnedGroup() {
            if (!this.keyCheck(this.newGroup.gtype == 'private' ? 0 : 1, this.newGroup.name, this.newGroup.group_key,this.newGroup.teacher_key)) {
                return
            }
           
            const data = {               
                name : this.newGroup.name,
                group_key : this.newGroup.gtype == 'private' ? this.newGroup.group_key : '',
                teacher_key : this.newGroup.gtype == 'private' ? this.newGroup.teacher_key : '',
                group_type: this.newGroup.gtype == 'private' ? 0 : 1
            }
            axios.post('/add-group', data, this.$store.getters.getAxiosConfig)
                .then(res => {      
                    if (res.data.message == 'OK') {
                        const _d = {
                            id: res.data.id,
                            name: data.name,
                            type: data.group_type,
                            group_key: data.group_key,
                            teacher_key: data.teacher_key
                        }
                        this.groups.push(_d)
                        this.my_owns.push(_d)
                        this.refreshDataForCombo(this.groups)
                        this.show_group_info = 0
                    } else {
                        this.feedback = res.data.description
                    }
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 
        },
        isOwner(g) {
            for(let i=0; i<this.my_owns.length; i++) {
                if (g == this.my_owns[i].name) return true
            }
            return false;
        },
        addToGroups() {
            const _group = this.groups1[0]
            this.groups1 = []
            // if it is in my group - away
            for(let i=0; i<this.my_groups.length; i++) {
                if (this.my_groups[i].name == _group) {
                    this.group_list.splice(this.group_list.indexOf(_group),1)
                    return
                }
            }
            
            this.full_group = null
            for(let i=0; i<this.groups.length; i++) {
                if (this.groups[i].name == _group) {
                    this.full_group = {
                        id : this.groups[i].id,
                        name: this.groups[i].name,
                        type: this.groups[i].type,
                        group_key: this.groups[i].group_key,
                        teacher_key : this.groups[i].teacher_key
                    }
                }
            }

            // this.group_list.splice(this.group_list.indexOf(_group),1)
            if (this.full_group == null) return
            if (!this.isOwner(_group) && this.full_group.type == 0) {
                this.$store.commit('setShowModalMessage',
                            {content: '"'+_group+'" is a private group. Type group key.', type: 'warning', 
                                buttons:[], icons:[{text:'close', color:'red', value: 7},{text:'done', color:'green', value: 8}], input: 1})
            } else {
                this.addNewGroup(1)
            }
        },
        addToTeacherGroups() {
            const _group = this.groups2[0]
            this.groups2 = []
            // if it is in my group - away
            for(let i=0; i<this.my_teach_groups.length; i++) {
                if (this.my_teach_groups[i].name == _group) {
                    this.private_group_list.splice(this.private_group_list.indexOf(_group),1)
                    return
                }
            }

            this.full_group = null
            for(let i=0; i<this.groups.length; i++) {
                if (this.groups[i].name == _group) {
                    this.full_group = {
                        id : this.groups[i].id,
                        name: this.groups[i].name,
                        type: this.groups[i].type,
                        group_key: this.groups[i].group_key,
                        teacher_key : this.groups[i].teacher_key
                    }
                }
            }

           // this.private_group_list.splice(this.private_group_list.indexOf(_group),1)
            if (this.full_group == null) return
            if (!this.isOwner(_group) && this.full_group.type == 0) {
                this.$store.commit('setShowModalMessage',
                            {content: '"'+_group+'" is a private teaching group. Type teacher key.', type: 'warning', 
                                buttons:[], icons:[{text:'close', color:'red', value: 9},{text:'done', color:'green', value: 10}], input: 1})
            } else {
                this.addNewGroup(2)
            }
        },
        addNewGroup(_type) {            
            this.feedback1 = null
            this.feedback2 = null
            // check get_group_key - 1 obycajna 2 - teacher
            const data = {
                list_type : _type,
                id: this.full_group.id,
                group_key: this.full_group.group_key,
                teacher_key : this.full_group.teacher_key,
                group_type : this.full_group.type
            }
            const myGroup = this.full_group
            axios.post('/add-to-group', data, this.$store.getters.getAxiosConfig)
                .then(res => {      
                    if (res.data.message == 'OK') {
                        if (_type == 1) {
                            
                            this.my_groups.push(myGroup)
                            this.group_list.splice(this.group_list.indexOf(myGroup.name),1)
                        }
                        if (_type == 2) {
                            this.my_teach_groups.push(myGroup)
                            this.private_group_list.splice(this.private_group_list.indexOf(myGroup.name),1)
                        }
                    } else {
                        if (_type == 1)
                            this.feedback1 = res.data.description
                        if (_type == 2)
                            this.feedback2 = res.data.description
                    }
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 

        }

    }
}
</script>


